import React, { useMemo } from 'react'
import { Box, Divider, Typography } from '@mui/material'
import { useCritiqueStyles } from './styles'
import TrustPilotRatingWidget from '../../components/TrustPilot/TrustPilotRatingWidget'
import { TrustPilotRatingWidget as ITrustPilotRatingWidget } from 'types/page'
import { Carousel as ICarousel } from 'types/carousel'
import CarouselSection from '../../components/LandingPage/CarouselSection'
import { useTrustPilotTaggedReviews } from '../../hooks/useTrustPilotReviews'
import useBrand from '../../hooks/useBrand'

export interface CritiqueSideTestimonialsProps {
  trustpilotWidget: ITrustPilotRatingWidget
  carousel: ICarousel
}

export const TestimonialSlide: React.FC<{ body: string; name: string }> = ({
  body,
  name,
}) => {
  const { classes, cx } = useCritiqueStyles()

  return (
    <Box display="flex" flexDirection="column" gap="8px" textAlign="center">
      <Typography
        variant="inherit"
        className={cx(classes.typographyMobileBody, classes.neutralLight)}
      >
        {body.length > 180 ? `${body.slice(0, 180)} ...` : body}
      </Typography>
      <Typography
        variant="inherit"
        className={cx(classes.typographyMobileBody)}
      >
        — {name}
      </Typography>
    </Box>
  )
}

export const CritiqueSideTestimonials: React.FC<
  CritiqueSideTestimonialsProps
> = ({ trustpilotWidget, carousel }) => {
  const { classes, cx } = useCritiqueStyles()
  const brand = useBrand()
  const reviews = useTrustPilotTaggedReviews(
    'shown-on-website',
    brand.display_name
  )
  const mappedReviewsCarousel = useMemo(() => {
    return Object.assign(carousel, {
      slides: reviews.map((review) => ({
        body: review.text,
        name: review.consumer.displayName,
        __typename: 'SimpleSlide',
      })),
    })
  }, [reviews, carousel])

  return (
    <Box
      display="flex"
      flexDirection="column"
      className={cx(
        classes.outlinedContainer,
        classes.testimonialSlides,
        classes.bottomPadding,
        'critique-testimonial'
      )}
      gap="24px"
    >
      <TrustPilotRatingWidget reference={trustpilotWidget} />
      <Divider />
      <CarouselSection
        carouselSection={mappedReviewsCarousel}
        transparentBackground
      />
    </Box>
  )
}
